<wj-flex-grid
    #flexGrid
    [alternatingRowStep]="0"
    [selectionMode]="'ListBox'"
    [allowSorting]="false"
    [autoRowHeights]="true"
    [frozenColumns]="7"
    [headersVisibility]="'Column'"
    (initialized)="initializedGrid(flexGrid)">
    <wj-flex-grid-column
        [allowResizing]="false"
        [allowDragging]="false"
        [isRequired]="false"
        [width]="35"
        [isReadOnly]="true">
        <ng-template
            wjFlexGridCellTemplate
            [autoSizeRows]="false"
            [cellType]="'Cell'">
            <mat-icon
                class="edit-template"
                (click)="openStory(flexGrid, $event)"
                >edit</mat-icon
            >
        </ng-template>
    </wj-flex-grid-column>

    <wj-flex-grid-column
        [allowResizing]="false"
        [allowDragging]="false"
        [isRequired]="false"
        [width]="35"
        [isReadOnly]="true">
        <ng-template
            wjFlexGridCellTemplate
            [autoSizeRows]="false"
            [cellType]="'Cell'">
            <mat-icon
                class="edit-template"
                (click)="deleteBasicContent(flexGrid, $event)"
                >delete</mat-icon
            >
        </ng-template>
    </wj-flex-grid-column>
    @for (column of gridLayout().columns; track column.name) {
        @switch (column.name) {
            @case (PSTFieldNames.MOSStatus) {
                <wj-flex-grid-column
                    class="mos-status-column"
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="true"
                    [multiLine]="true"
                    [isContentHtml]="true"
                    [minWidth]="100"
                    [quickAutoSize]="column.autoSizeWidth"
                    [width]="column.width">
                    <ng-template
                        let-cell="cell"
                        wjFlexGridCellTemplate
                        [cellType]="'Cell'">
                        <div style="display: flex; flex-direction: column">
                            @for (status of cell.item?.MOSStatus?.split('\r\n'); track status) {
                                <span
                                    class="mos-status"
                                    [attr.mos-status]="status"
                                    >{{ status }}</span
                                >
                            }
                        </div>
                    </ng-template>
                </wj-flex-grid-column>
            }
            @case (PSTFieldNames.MOSChannels) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="true"
                    [minWidth]="100"
                    [multiLine]="true"
                    [quickAutoSize]="column.autoSizeWidth"
                    [width]="column.width">
                    <ng-template
                        let-cell="cell"
                        wjFlexGridCellTemplate
                        [cellType]="'Cell'">
                        <div style="display: flex; flex-direction: column">
                            @if (cell.item.MOSChannels | isArray) {
                                @for (channel of cell.item.MOSChannels; track channel) {
                                    <span>{{ channel }}</span>
                                }
                            } @else {
                                <span>{{ cell.item.MOSChannels }}</span>
                            }
                        </div>
                    </ng-template>
                </wj-flex-grid-column>
            }
            @case (PSTFieldNames.MOSAbstracts) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="true"
                    [minWidth]="100"
                    [multiLine]="true"
                    [quickAutoSize]="column.autoSizeWidth"
                    [width]="column.width" />
            }
            @case (PSTFieldNames.MOSIDs) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="true"
                    [minWidth]="100"
                    [multiLine]="true"
                    [quickAutoSize]="column.autoSizeWidth"
                    [width]="column.width" />
            }
            @case (PSTFieldNames.MOSSlugs) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="true"
                    [minWidth]="100"
                    [multiLine]="true"
                    [quickAutoSize]="column.autoSizeWidth"
                    [width]="column.width" />
            }
            @case (PSTFieldNames.MOSObjSlugs) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="true"
                    [minWidth]="100"
                    [multiLine]="true"
                    [quickAutoSize]="column.autoSizeWidth"
                    [width]="column.width" />
            }
            @case (PSTFieldNames.MOSItemDurations) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="true"
                    [minWidth]="100"
                    [multiLine]="true"
                    [quickAutoSize]="column.autoSizeWidth"
                    [width]="column.width" />
            }
            @case (PSTFieldNames.ObjectAutoCreate) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="column.isReadOnly"
                    [minWidth]="100"
                    [quickAutoSize]="column.autoSizeWidth"
                    [dataMap]="column.columnListDataMap"
                    [editor]="comboEditor"
                    [width]="column.width" />
                <wj-combo-box
                    #comboEditor
                    [selectedValuePath]="'id'"
                    [displayMemberPath]="'title'"
                    [itemsSource]="autoCreateMosDeviceItems" />
            }
            @case (PSTFieldNames.MOSTimes) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="true"
                    [minWidth]="100"
                    [multiLine]="true"
                    [quickAutoSize]="column.autoSizeWidth"
                    [width]="column.width" />
            }
            @case (PSTFieldNames.ObjectPlaceholderCreate) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="true"
                    [minWidth]="100"
                    [quickAutoSize]="column.autoSizeWidth"
                    [width]="column.width">
                    <ng-template
                        let-cell="cell"
                        wjFlexGridCellTemplate
                        [cellType]="'Cell'">
                        <div
                            #btnClickNone
                            class="object-placeholder-create-value">
                            {{ cell.item.ObjectPlaceholderCreate }}
                        </div>
                        <wj-popup
                            #objectPlaceHolderCreatePopup
                            class="popover"
                            [owner]="btnClickNone"
                            [showTrigger]="'Click'"
                            [hideTrigger]="'None'">
                            <div class="object-placeholder-create-popup">
                                <div class="wj-labeled-input">
                                    <wj-combo-box
                                        #mosDevicesCb
                                        [selectedValuePath]="'id'"
                                        [displayMemberPath]="'title'"
                                        [itemsSource]="autoCreateMosDeviceItems"
                                        (selectedIndexChanged)="onMosTypeChanged(mosDevicesCb.selectedIndex, mosTypesCb)" />
                                    <label for="mosDevicesCb">MOS</label>
                                </div>
                                @let mosGroupCbItems = autoCreateMosDeviceItems[mosDevicesCb.selectedIndex]?.definedGroups;
                                <div class="wj-labeled-input">
                                    <wj-combo-box
                                        #mosGroupsCb
                                        [itemsSource]="mosGroupCbItems?.length ? mosGroupCbItems : null" />
                                    <label for="mosGroupsCb">Group</label>
                                </div>
                                <div class="wj-labeled-input">
                                    <wj-combo-box
                                        #mosTypesCb
                                        [selectedValuePath]="'id'"
                                        [displayMemberPath]="'title'"
                                        [itemsSource]="mosTypes()" />
                                    <label for="mosTypesCb">Type</label>
                                </div>
                                <div class="wj-labeled-input">
                                    <wj-combo-box #mosSlugCb />
                                    <label for="mosSlugCb">Slug</label>
                                </div>
                                <button
                                    class="btn btn-danger wj-hide"
                                    (click)="cancelPlaceholderCreate(mosDevicesCb, mosGroupsCb, mosTypesCb, mosSlugCb, cell)">
                                    Cancel
                                </button>
                                <button
                                    class="btn btn-primary wj-hide-ok"
                                    (click)="createPlaceholder(mosDevicesCb, mosGroupsCb, mosTypesCb, mosSlugCb, cell)">
                                    Save
                                </button>
                            </div>
                        </wj-popup>
                    </ng-template>
                </wj-flex-grid-column>
            }
            @default {
                @switch (column.validation) {
                    @case (fieldDefValidations.COMBOBOX) {
                        <wj-flex-grid-column
                            [binding]="column.name"
                            [header]="column.displayName"
                            [isReadOnly]="column.isReadOnly"
                            [minWidth]="100"
                            [quickAutoSize]="column.autoSizeWidth"
                            [dataMap]="column.columnListDataMap"
                            [editor]="comboEditor"
                            [width]="column.width" />
                        <wj-combo-box
                            #comboEditor
                            [selectedValuePath]="'id'"
                            [displayMemberPath]="'title'"
                            [itemsSource]="column.columnList" />
                    }
                    @case (fieldDefValidations.CHECKLIST) {
                        <wj-flex-grid-column
                            [binding]="column.name"
                            [header]="column.displayName"
                            [isReadOnly]="column.isReadOnly"
                            [minWidth]="100"
                            [quickAutoSize]="column.autoSizeWidth"
                            [dataMap]="column.columnListDataMap"
                            [editor]="checkListEditor"
                            [width]="column.width" />
                        <wj-multi-select
                            #checkListEditor
                            [selectedValuePath]="'id'"
                            [displayMemberPath]="'title'"
                            [itemsSource]="column.columnList" />
                    }
                    @case (fieldDefValidations.CHECKLISTEDIT) {
                        <wj-flex-grid-column
                            [binding]="column.name"
                            [header]="column.displayName"
                            [isReadOnly]="column.isReadOnly"
                            [minWidth]="100"
                            [quickAutoSize]="column.autoSizeWidth"
                            [dataMap]="column.columnListDataMap"
                            [editor]="checkListEditEditor"
                            [width]="column.width" />
                        <wj-auto-complete
                            #checkListEditEditor
                            [selectedValuePath]="'id'"
                            [displayMemberPath]="'title'"
                            [itemsSource]="column.columnList" />
                    }
                    @case (fieldDefValidations.STAFFIDLIST) {
                        <wj-flex-grid-column
                            [binding]="column.name"
                            [header]="column.displayName"
                            [isReadOnly]="column.isReadOnly"
                            [minWidth]="100"
                            [quickAutoSize]="column.autoSizeWidth"
                            [dataMap]="column.columnListDataMap"
                            [editor]="staffIdListEditor"
                            [width]="column.width" />
                        <wj-combo-box
                            #staffIdListEditor
                            [selectedValuePath]="'id'"
                            [displayMemberPath]="'title'"
                            [itemsSource]="column.columnList" />
                    }
                    @default {
                        <wj-flex-grid-column
                            [binding]="column.name"
                            [header]="column.displayName"
                            [isReadOnly]="column.isReadOnly"
                            [minWidth]="column.width || 100"
                            [quickAutoSize]="column.autoSizeWidth"
                            [width]="column.width" />
                    }
                }
            }
        }
    }
</wj-flex-grid>

<div class="st-ro-grid-timing-bar">
    {{ timingOverUnder() }}
    <span
        *ngIf="timingSelection()"
        class="st-ro-grid-timing-selection"
        >SELECTION {{ timingSelection() }}</span
    >
</div>
